import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import GraphTable from "./GraphTable";

export const RESERVE_BREAKDOWN_COLUMNS = [
  { key: "lease_reference", label: "Lease Reference" },
  { key: "reserve_rate_name", label: "Reserve Rate" },
  { key: "item", label: "Item" },
  { key: "invoice_number", label: "Invoice No." },
  { key: "amount", label: "Amount", mono: true },
];

export function formatReserveAmount(value) {
  const amount = typeof value === "number" ? value : parseFloat(value);
  if (Number.isNaN(amount)) return "-";
  return amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function buildReserveBreakdownRows(items) {
  if (!Array.isArray(items)) return [];
  return items.map((item, index) => ({
    id: `${item?.invoice_number || item?.lease_slug || "row"}-${index}`,
    lease_reference: item?.lease_reference || "-",
    reserve_rate_name: item?.reserve_rate_name || "-",
    item: item?.item || "-",
    invoice_number: item?.invoice_number || "-",
    amount: formatReserveAmount(item?.amount),
  }));
}

const ReserveBreakdownModal = ({ open, onClose, rows, title }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle sx={{ m: 0, p: 2 }}>{title || "Reserve Breakdown"}</DialogTitle>
    <DialogContent dividers sx={{ p: 2 }}>
      <GraphTable columns={RESERVE_BREAKDOWN_COLUMNS} rows={rows} maxHeight={420} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="outlined" size="small">Close</Button>
    </DialogActions>
  </Dialog>
);

export default ReserveBreakdownModal;
